const WebLocationService = {
  getLocation() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (data) => {
          const res = {
            latitude: data.coords.latitude,
            longitude: data.coords.longitude,
          };
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  ipBasedLocation() {
    return new Promise((resolve, reject) => {
      fetch("https://ip-api.com/json").then((data) =>
        data
          .json()
          .then((parsedData) => resolve(parsedData))
          .catch((err) => reject(err))
      );
    });
  },
};
export default WebLocationService;
